module.exports = __webpack_public_path__ + "static/media/SF-2-if-wrong.88f0b869.mp3";